<script>
  import { createEventDispatcher, onMount } from "svelte";
  import { toArray, getWrittenName } from "../../utils/utilities";

  export let options;
  export let currency;
  export let showAsTable = false;

  const dispatch = createEventDispatcher();
  const isMultiple = options.multiple;

  let selectedValues = [];

  onMount(() => {
    if (options.val) {
      selectedValues = options.val.split("||").filter(Boolean);
    }
  });

  function toggleOption(option) {
    if (isMultiple) {
      if (selectedValues.includes(option)) {
        selectedValues = selectedValues.filter((v) => v !== option);
      } else {
        selectedValues = [...selectedValues, option];
      }
    } else {
      selectedValues = [option];
      send();
    }
    selectedValues = [...selectedValues];
  }

  function isSelected(option) {
    return selectedValues.includes(option);
  }

  function send() {
    const finalValue = isMultiple ? selectedValues.join("||") : selectedValues[0] ?? "";
    dispatch("message", finalValue);
  }
</script>

<div class="scale-in-center">
  <div class="chatwith-button-options-container">
    <div class="chatwith-button-options" class:buttons-as-table={showAsTable}>
      <div class="chatwith-button-options" class:buttons-as-table={showAsTable}>
        {#each toArray(options.data) as data (selectedValues.join() + data)}
          <button type="button" class="chatwith-option-button" class:selected={isSelected(data)} on:click={() => toggleOption(data)}>
            {getWrittenName(data, options?.dataObject, options?.showPrices, currency)}
          </button>
        {/each}
      </div>
    </div>

    {#if isMultiple}
      <button on:click={send} class="chatwith-chat-sendbutton">
        <svg style="width: 18px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path
            fill="currentColor"
            d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
          />
        </svg>
      </button>
    {/if}
  </div>
</div>

<style>
  .chatwith-option-button.selected {
    background-color: #ddd;
  }
</style>
